import React, { useState, useEffect } from 'react';

const STYLES = {
  error: { border: '#FF3B5C', bg: 'rgba(255,59,92,0.08)', icon: '\u2715', iconBg: 'rgba(255,59,92,0.15)', iconColor: '#FF3B5C' },
  warning: { border: '#E8C547', bg: 'rgba(232,197,71,0.08)', icon: '\u26A0', iconBg: 'rgba(232,197,71,0.15)', iconColor: '#E8C547' },
  info: { border: '#00D4C8', bg: 'rgba(0,212,200,0.08)', icon: '\u2139', iconBg: 'rgba(0,212,200,0.15)', iconColor: '#00D4C8' },
};

const InlineMessage = ({ type = 'warning', title, message, suggestions = [], actions = [], onDismiss, autoDismiss }) => {
  const [visible, setVisible] = useState(true);
  const s = STYLES[type] || STYLES.warning;

  useEffect(() => {
    if (autoDismiss && autoDismiss > 0) {
      const t = setTimeout(() => { setVisible(false); onDismiss?.(); }, autoDismiss);
      return () => clearTimeout(t);
    }
  }, [autoDismiss, onDismiss]);

  if (!visible) return null;

  return (
    <div style={{
      borderLeft: `3px solid ${s.border}`,
      background: s.bg,
      borderRadius: '0 8px 8px 0',
      padding: '12px 16px',
      marginBottom: 12,
      animation: 'inlineMsgIn 250ms ease',
      fontFamily: "'Inter', sans-serif",
    }}>
      <style>{`@keyframes inlineMsgIn{from{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}`}</style>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
        <div style={{ display: 'flex', gap: 10, flex: 1 }}>
          <div style={{
            width: 24, height: 24, borderRadius: '50%', background: s.iconBg,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 12, color: s.iconColor, flexShrink: 0, marginTop: 1,
          }}>
            {s.icon}
          </div>
          <div style={{ flex: 1 }}>
            {title && <p style={{ fontSize: 13, fontWeight: 600, color: s.iconColor, marginBottom: 4 }}>{title}</p>}
            {message && <p style={{ fontSize: 13, color: '#8899AA', lineHeight: 1.5 }}>{message}</p>}
            {suggestions.length > 0 && (
              <ul style={{ margin: '6px 0 0', padding: 0, listStyle: 'none' }}>
                {suggestions.map((sug, i) => (
                  <li key={i} style={{ fontSize: 12, color: '#8899AA', lineHeight: 1.6, paddingLeft: 12, position: 'relative' }}>
                    <span style={{ position: 'absolute', left: 0, color: s.iconColor }}>{'\u2192'}</span>
                    {sug}
                  </li>
                ))}
              </ul>
            )}
            {actions.length > 0 && (
              <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                {actions.map((a, i) => (
                  <button key={i} onClick={a.onClick} style={{
                    padding: '6px 14px', fontSize: 12, fontWeight: 600, borderRadius: 6, cursor: 'pointer',
                    background: i === 0 ? s.iconColor : 'transparent',
                    color: i === 0 ? '#03050A' : s.iconColor,
                    border: i === 0 ? 'none' : `1px solid ${s.border}`,
                  }}>
                    {a.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
        {onDismiss && (
          <button onClick={() => { setVisible(false); onDismiss(); }} style={{ background: 'none', border: 'none', color: '#8899AA', cursor: 'pointer', fontSize: 14, padding: 0 }}>{'\u00D7'}</button>
        )}
      </div>
    </div>
  );
};

export default InlineMessage;
